import React from 'react';
import '../styles/Trabajos.css';
import '../styles/index.css';
import '../styles/main.css';

const TrabajoCard = ({ trabajo, filtroColores }) => {
    const nombreAutor = trabajo.usuarioId?.nombre && trabajo.usuarioId?.apellido
      ? `Hecho por: ${trabajo.usuarioId.nombre} ${trabajo.usuarioId.apellido}`
      : 'Hecho por: Anónimo';
  
    const fechaFormateada = new Date(trabajo.createdAt).toLocaleDateString();
  
    const imagenPortada = trabajo.imagenPortada
      ? `/trabajosusers/${trabajo.imagenPortada}`
      : '/images/placeholder.png';
  
    return (
      <>
        <div className="col-md-6">
          <a href={`/trabajos/${trabajo._id}`}>
            <img
              className="img-fluid"
              src={imagenPortada}
              alt={trabajo.titulo}
              style={{
                width: '100%',
                height: '325px',
                objectFit: 'cover',
                borderRadius: '12px'
              }}
            />
          </a>
        </div>
  
        <div className="col-md-6 d-flex flex-column justify-content-between" style={{ padding: '16px', minHeight: '325px' }}>
          <div className="contenido-trabajo">
            <h3 className="mb-2">{trabajo.titulo}</h3>
            <h5 className="mb-2">{nombreAutor}</h5>
            <p className="truncate-description mb-3">{trabajo.descripcion}</p>
            <p className="mb-3">Fecha: {fechaFormateada}</p>
          </div>
  
          <div className="acciones-trabajo mt-auto">
            <div className="d-flex align-items-center justify-content-start gap-3 flex-wrap">
            {trabajo.filtros.map((filtro, index) => {
            const color = filtroColores?.[filtro] || 'secondary';
            return (
                <span
                key={index}
                className={`badge bg-${color} px-3 py-2 fs-6 rounded`}
                >
                {filtro}
                </span>
            );
            })}
            </div>
            <hr />
            <div className="d-flex align-items-center justify-content-start gap-3 flex-wrap">
              <a className="btn btn1-custom" href={`/trabajos/${trabajo._id}`}>
                Ver detalles
              </a>
            </div>
          </div>
        </div>
      </>
    );
  };
  
  export default TrabajoCard;